import { render, staticRenderFns } from "./PAYGUpgradeComplete.vue?vue&type=template&id=e1d3c800&"
import script from "./PAYGUpgradeComplete.vue?vue&type=script&lang=js&"
export * from "./PAYGUpgradeComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports